import View from "@pathwright/ui/src/components/ui/View"
import ResourceLicenseOfferingForm from "./ResourceLicenseOfferingForm"
import "./ResourceOffering.css"
import ResourceOfferingFormContainer from "./ResourceOfferingFormContainer"
import ResourceOfferingInfo from "./ResourceOfferingInfo"

const ResourceOffering = function ({ resource, offering }) {
  const showForm =
    !!offering.permissions &&
    ((offering.permissions.can_access && !offering.permissions.can_edit) ||
      !offering.permissions.can_facilitate)

  return (
    <View.Primary className="ResourceOffering" rounded shadow>
      <View borderBottom={showForm}>
        <ResourceOfferingInfo resource={resource} offering={offering} />
      </View>
      {showForm ? (
        offering.is_license_offering ? (
          <ResourceLicenseOfferingForm offering={offering} />
        ) : (
          <ResourceOfferingFormContainer offering={offering} />
        )
      ) : null}
    </View.Primary>
  )
}

ResourceOffering.displayName = "ResourceOffering"
export default ResourceOffering
